import React from 'react'

const PortfolioGrid = () => {
  // Function to detect device and redirect to appropriate app store
  const handleAppStoreClick = (appName) => {
    // Define app store URLs for each app
    const appUrls = {
        'Talent Lockr': {
            ios: 'https://apps.apple.com/us/app/talent-lockr/id6444275012',
            android: 'https://play.google.com/store/search?q=talentlockr&c=apps&hl=en'
        },
        'Bolt For Gold': {
            ios: '#',
            android: '#'
        },
        'Ibiza Only': {
            ios: 'https://apps.apple.com/au/app/ibiza-only/id6738636443',
            android: 'https://play.google.com/store/apps/details?id=io.everestapps.ibizaonly&hl=en'
        },
        'IAW Charity': {
            ios: '#',
            android: '#'
        }
    };
    
    // Check if the app exists in our mapping
    if (!appUrls[appName]) {
        console.error(`No URLs defined for app: ${appName}`);
        return;
    }
    
    // Detect if user is on iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    // Detect if user is on Mac
    const isMac = /Mac/.test(navigator.userAgent);
    
    // Redirect to appropriate store based on device
    if (isIOS || isMac) {
        window.open(appUrls[appName].ios, '_blank');
    } else {
        window.open(appUrls[appName].android, '_blank');
    }
};
  return (
    <div className='px-4 py-12 bg-[#00101D]'>

      <div className="container -mt-24 md:hidden px-6 mb-10 py-8 bg-[#001322] shadow-lg mx-auto max-w-xs">
        <h2 className="text-3xl md:text-6xl font-bold text-primary mb-2 max-w-[12rem]">Apps that climb the summit</h2>
        <p className="md:text-2xl text-white max-w-2xl text-sm">
          Real results real users, built for scale, performance with vision.
        </p>
      </div>

      <div className="grid max-w-7xl mx-auto grid-cols-1 md:grid-cols-2 gap-8 w-full" >
        {/* Talent Lockr */}

        <div className="bg-[#000B14] rounded-3xl p-6" >
          <div className="flex gap-6 mb-4 md:flex-row">
            <div className="">
              <div className="w-24 lg:w-[200px]">
                <img
                  src="/assets/talent-lockr.jpg"
                  alt="Talent Lockr"
                  className="w-full h-auto rounded-lg"
                  onError={(e) => e.target.src = 'https://via.placeholder.com/150?text=Talent+Lockr'}
                />
              </div>
            </div>
            <div className="w-full flex flex-col justify-center">
              <h3 className="text-2xl font-bold text-white mb-2 lg:text-3xl lg:font-extrabold">Talent Lockr</h3>
              <p className="text-sm lg:text-2xl text-white">Athlete network for players, schools & scouts</p>
            </div>
          </div>
          <div className="flex flex-col gap-0 relative">
            <ul className="text-gray-300 space-y-1 mb-4 text-sm lg:text-lg font-medium pl-20 md:pl-6 py-4">
              <li className="flex items-center"><span className="mr-2">•</span> Athlete profiles and highlights</li>
              <li className="flex items-center"><span className="mr-2">•</span> School matching systems</li>
              <li className="flex items-center"><span className="mr-2">•</span> School dashboards</li>
            </ul>
            <button className="inline-flex self-end items-center bg-white text-black rounded-md px-4 py-2.5 font-semibold" onClick={() => handleAppStoreClick('Talent Lockr')}>
              <svg className="w-6 h-6 mr-1" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              App Store
            </button>
          </div>
        </div>

        {/* Ibiza Only */}
        <div className="bg-[#000B14] rounded-3xl p-6" >
          <div className="flex gap-6 mb-4">
            <div className="">
              <div className="w-24 lg:w-[200px]">
                <img
                  src="/assets/ibiza-only.jpg"
                  alt="Ibiza Only"
                  className="w-full h-auto rounded-lg"
                  onError={(e) => e.target.src = 'https://via.placeholder.com/150?text=Talent+Lockr'}
                />
              </div>
            </div>
            <div className="w-full md:w-2/3 flex flex-col justify-center">
              <h3 className="text-2xl font-bold text-white mb-2 lg:text-3xl lg:font-extrabold">Ibiza Only</h3>
              <p className="text-sm lg:text-2xl text-white">For Ibiza concierge & letting</p>
            </div>
          </div>
          <div className="flex flex-col gap-0 relative">
            <ul className="text-gray-300 space-y-1 mb-4 text-sm lg:text-lg font-medium pl-20 md:pl-6 py-4">
              <li className="flex items-center"><span className="mr-2">•</span> Dating platform</li>
              <li className="flex items-center"><span className="mr-2">•</span> Event recommendations</li>
              <li className="flex items-center"><span className="mr-2">•</span> Personal assistance</li>
            </ul>
            <button className="inline-flex self-end items-center bg-white text-black rounded-md px-4 py-2.5 font-semibold" onClick={() => handleAppStoreClick('Ibiza Only')}>
              <svg className="w-6 h-6 mr-1" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              App Store
            </button>
          </div>
        </div>

        {/* Bolt for Gold */}
        <div div className="bg-[#000B14] rounded-3xl p-6" >
          <div className="flex gap-6 mb-4">
            <div className="">
              <div className="w-24 lg:w-[200px]">
                <img
                  src="/assets/bolt-for-gold.jpg"
                  alt="Bolt for Gold"
                  className="w-full h-auto rounded-lg"
                  onError={(e) => e.target.src = 'https://via.placeholder.com/150?text=Talent+Lockr'}
                />
              </div>
            </div>
            <div className="w-full md:w-2/3 flex flex-col justify-center">
              <h3 className="text-2xl font-bold text-white mb-2 lg:text-3xl lg:font-extrabold">Bolt for Gold</h3>
              <p className="text-sm lg:text-2xl text-white">For schools and charities</p>
            </div>
          </div>
          <div className="flex flex-col gap-0 relative">
            <ul className="text-gray-300 space-y-1 mb-4 text-sm lg:text-lg font-medium pl-20 md:pl-6 py-4">
              <li className="flex items-center"><span className="mr-2">•</span> Race challenges</li>
              <li className="flex items-center"><span className="mr-2">•</span> Live leaderboards</li>
              <li className="flex items-center"><span className="mr-2">•</span> Fundraising integration</li>
            </ul>
            <button className="inline-flex self-end items-center bg-white text-black rounded-md px-4 py-2.5 font-semibold" onClick={() => handleAppStoreClick('Bolt For Gold')}>
              <svg className="w-6 h-6 mr-1" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              App Store
            </button>
          </div>
        </div>

        {/* IAW Charity */}
        <div div className="bg-[#000B14] rounded-3xl p-6" >
          <div className="flex gap-6 mb-4">
            <div className="">
              <div className="w-24 lg:w-[200px]">
                <img
                  src="/assets/iaw.png"
                  alt="IAW Charity"
                  className="w-full h-auto rounded-lg"
                  onError={(e) => e.target.src = 'https://via.placeholder.com/150?text=Talent+Lockr'}
                />
              </div>
            </div>
            <div className="w-full md:w-2/3 flex flex-col justify-center">
              <h3 className="text-2xl font-bold text-white mb-2 lg:text-3xl lg:font-extrabold">IAW Charity</h3>
              <p className="text-sm lg:text-2xl text-white">Online Donation Portal</p>
            </div>
          </div>
          <div className="flex flex-col gap-0 relative">
            <ul className="text-gray-300 space-y-1 mb-4 text-sm lg:text-lg font-medium pl-20 md:pl-6 py-4">
              <li className="flex items-center"><span className="mr-2">•</span> Donation platform</li>
              <li className="flex items-center"><span className="mr-2">•</span> Ramadan campaigns</li>
              <li className="flex items-center"><span className="mr-2">•</span> Secure payments</li>
            </ul>
            <button className="inline-flex self-end items-center bg-white text-black rounded-md px-4 py-2.5 font-semibold" onClick={() => handleAppStoreClick('IAW Charity')}>
              <svg className="w-6 h-6 mr-1" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              App Store
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PortfolioGrid